import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList";
import PencilIcon from "vue-material-design-icons/Pencil";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Main",
    children: [
      {
        name: "Job",
        children: [
          {
            icon: "view-list",
            title: "List Job",
            to: {
              name: "job.list",
              query: { limit: 50, filter: "current", sort: "job_date" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Job",
            to: { name: "job.create" },
            loggedIn: true,
          },
          // {
          //   icon: 'view-list',
          //   title: 'Job Allocate',
          //   to: {name: 'job.allocate', query: {limit: 10, filter: 'active'}},
          //   loggedIn: true,
          // },
        ],
        loggedIn: true,
      },
      {
        name: "Daily Schedule",
        children: [
          {
            icon: "view-list",
            title: "List Daily Schedule",
            to: {
              name: "job.allocate",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
  {
    name: "Admin",
    children: [
      {
        name: "Manage",
        children: [
          {
            icon: "view-list",
            title: "List Customer",
            to: {
              name: "customer.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Pump",
            to: { name: "pump.list", query: { limit: 10, filter: "active" } },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Site Contact",
            to: {
              name: "site_contact.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Job Type",
            to: {
              name: "code_job_type.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Supplier",
            to: {
              name: "supplier.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List File Type",
            to: {
              name: "code_file_type.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Supervisor",
            to: {
              name: "supervisor.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Employees",
            to: {
              name: "employee.list",
              query: { limit: 10, filter: "active" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Area",
            to: { name: "code_area.list", query: { limit: 10, filter: "all" } },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Users & Roles",
        children: [
          {
            icon: "view-list",
            title: "List Users",
            to: { name: "user.list", query: { limit: 10, filter: "all" } },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Groups",
            to: { name: "group.list", query: { limit: 10, filter: "all" } },
            loggedIn: true,
          },

          {
            icon: "view-list",
            title: "List Group Permissions",
            to: {
              name: "group_permissions.list",
              query: { limit: 10, filter: "all" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
];
